import type { ValidationRuleGenerator } from "../scenarioValidator";
import { catastropheChecks } from "./catastopheChecks";
import { deviationSurveyChecks } from "./deviationSurveyChecks";
import { gasCompositionChecks } from "./gasCompositionChecks";
import { intakeChecks } from "./intakeChecks";
import { intakeConditionChecks } from "./intakeConditionVals";
import { motorChecks } from "./motorChecks";
import { obsolescenceChecks } from "./obsolescenceChecks";
import { powerCableChecks } from "./powerCableChecks";
import { pumpChecks } from "./pumpChecks";
import { sealChecks } from "./sealChecks";
import { sealMotorOilChecks } from "./sealMotorOilChecks";
import { shroudChecks } from "./shroudChecks";
import { surfaceDriveChecks } from "./surfaceDriveChecks";
import { tubingSizeChecks } from "./tubingSizeChecks";

// If adding test or editing test name
// modify ../validationTestName.ts accordingly

export const generateAllValidationRules: ValidationRuleGenerator = args =>
  [
    obsolescenceChecks, // Keep these first to always show in tooltip
    intakeConditionChecks,
    tubingSizeChecks,
    deviationSurveyChecks,
    gasCompositionChecks,
    intakeChecks,
    pumpChecks,
    sealChecks,
    sealMotorOilChecks,
    shroudChecks,
    powerCableChecks,
    motorChecks,
    surfaceDriveChecks,
    catastropheChecks
  ].flatMap(checkGenerator => checkGenerator(args));
